export function acknowledgeMatchMessage(record: { message: string; syncRequired: number }, messageId: string) {
  // An older request can finish after a newer match snapshot was queued.
  // Only the acknowledgement for this exact snapshot may clear its pending flag.
  if (JSON.parse(record.message).messageId === messageId) record.syncRequired = 0
}
